import axios from "axios";

function fetchData(url) {
  const res = axios
    .get(process.env.REACT_APP_API + url)
    .then((res) => res.data.total)
    .catch((err) => {
      console.log(err);
    });

  return res;
}

export default fetchData;
